import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { HeroWrapper, TextWrapperBox, StyledHeroText, DesktopImage, MobileImage } from './OurStoryHero.styles';
import { useTranslation } from 'react-i18next';

export const OurStoryHero = () => {
  const { t } = useTranslation('ourStory');
  const heroSection = t('heroSection');
  return (
    <HeroWrapper>
      <DesktopImage src="our-story/hero/hero.jpg" width="100%" optimization="aggressive" />
      <MobileImage src="our-story/hero/mobile-hero.jpg" width="100%" optimization="aggressive" />
      <TextWrapperBox>
        <StyledHeroText variant="hed72Hero" color="mono7" tagName="h1">
          {ReactHtmlParser(heroSection.title)}
        </StyledHeroText>
      </TextWrapperBox>
    </HeroWrapper>
  );
};
